// GENERATED by scripts/generate-legacy-endpoints.mjs — do not edit by hand.
// Source: MyPoz OutterApi document. Re-run the script when the document is revised.
//
// 45 of the document's 50 endpoints. The other 5 are callbacks the browser never calls, and
// MYP-78 tracks whether they are alive at all.
//
// Plus 1 from the vendor's top-up guide of 2026-10-26 (MYP-134): see TOP_UP_ENDPOINTS in the script.

import type { LegacyEndpoint } from './types.js';

export const LEGACY_ENDPOINTS = {
  package_list: {
    path: '/package_list',
    method: 'POST',
    envelope: 'standard',
    title: '获取包裹列表/详情',
    codes: {
      '1': '查询成功。',
      '-2': '非 POST 请求。',
    },
  },
  add_packages: {
    path: '/add_packages',
    method: 'POST',
    envelope: 'flatMessage',
    title: '添加/认领包裹',
    codes: {
      '1': '添加成功。',
      '2': '包裹或服务添加失败。',
      '3': '服务处理失败。',
      '4': '拆分包裹不能添加。',
    },
  },
  delete_package: {
    path: '/delete_package',
    method: 'POST',
    envelope: 'flatMessage',
    title: '删除包裹',
    codes: {
      '1': '删除成功。',
      '-2': '非 POST 或非法访问。',
    },
  },
  packages_services: {
    path: '/packages_services',
    method: 'POST',
    envelope: 'standard',
    title: '获取包裹增值服务',
    codes: {
      '1': '成功。',
    },
  },
  get_packages_msg: {
    path: '/get_packages_msg',
    method: 'POST',
    envelope: 'standard',
    title: '获取包裹留言',
    codes: {
      '1': '成功。',
      '-2': '非法访问。',
    },
  },
  post_packages_msg: {
    path: '/post_packages_msg',
    method: 'POST',
    envelope: 'flatMessage',
    title: '提交包裹留言',
    codes: {
      '1': '提交成功。',
      '2': '提交失败。',
      '3': '缺少参数。',
    },
  },
  warehouses: {
    path: '/warehouses',
    method: 'POST',
    envelope: 'standard',
    title: '获取仓库地址',
    codes: {
      '1': '成功。',
    },
  },
  order_status_list: {
    path: '/order_status_list',
    method: 'POST',
    envelope: 'standard',
    title: '订单状态列表',
    codes: {
      '1': '成功。',
    },
  },
  package_status: {
    path: '/package_status',
    method: 'POST',
    envelope: 'standard',
    title: '包裹状态字典',
    codes: {
      '1': '成功。',
    },
  },
  package_status_list: {
    path: '/package_status_list',
    method: 'POST',
    envelope: 'standard',
    title: '包裹状态列表',
    codes: {
      '1': '成功。',
    },
  },
  package_status_for_order_list: {
    path: '/package_status_for_order_list',
    method: 'POST',
    envelope: 'standard',
    title: '下单包裹状态列表',
    codes: {
      '1': '成功。',
    },
  },
  goods_type: {
    path: '/goods_type',
    method: 'POST',
    envelope: 'standard',
    title: '商品类型',
    codes: {
      '1': '成功。',
    },
  },
  order_status: {
    path: '/order_status',
    method: 'POST',
    envelope: 'standard',
    title: '订单状态字典',
    codes: {
      '1': '成功。',
    },
  },
  neworder_getChannel: {
    path: '/neworder_getChannel',
    method: 'POST',
    envelope: 'standard',
    title: '创建订单获取渠道',
    codes: {
      '1': '成功。',
      '2': '参数不完整或非法访问。',
      '-2': '非法请求方式。',
    },
  },
  channels: {
    path: '/channels',
    method: 'POST',
    envelope: 'standard',
    title: '渠道列表',
    codes: {
      '1': '成功。',
    },
  },
  country: {
    path: '/country',
    method: 'POST',
    envelope: 'standard',
    title: '国家列表',
    codes: {
      '1': '成功。',
    },
  },
  province: {
    path: '/province',
    method: 'POST',
    envelope: 'standard',
    title: '省份列表',
    codes: {
      '1': '成功。',
    },
  },
  city: {
    path: '/city',
    method: 'POST',
    envelope: 'standard',
    title: '城市列表',
    codes: {
      '1': '成功。',
    },
  },
  order_services: {
    path: '/order_services',
    method: 'POST',
    envelope: 'standard',
    title: '订单增值服务',
    codes: {
      '1': '成功。',
    },
  },
  order_list: {
    path: '/order_list',
    method: 'POST',
    envelope: 'dataOnly',
    title: '获取订单列表/详情',
    codes: {
      '-2': '非 POST。',
    },
  },
  orders_create: {
    path: '/orders_create',
    method: 'POST',
    envelope: 'flatRecord',
    title: '创建订单',
    codes: {
      '1': '创建成功。',
      '2': '缺少计费参数。',
    },
  },
  orders_pay: {
    path: '/orders_pay',
    method: 'POST',
    envelope: 'flatMessage',
    title: '订单支付',
    codes: {
      '0': '请选择订单或支付失败。',
      '1': '支付成功。',
      '2': '支付密码错误。',
      '3': '余额不足。',
      '-2': '缺少订单号或非法访问。',
    },
  },
  order_receive: {
    path: '/order_receive',
    method: 'POST',
    envelope: 'flatMessage',
    title: '订单确认收货',
    codes: {
      '1': '收货成功。',
      '-2': '缺少订单号。',
    },
  },
  order_cancel: {
    path: '/order_cancel',
    method: 'POST',
    envelope: 'flatMessage',
    title: '订单取消/退单',
    codes: {
      '1': '退单成功。',
      '2': '退单失败。',
      '-2': '缺少订单号。',
    },
  },
  OrderCodenoCheck: {
    path: '/OrderCodenoCheck',
    method: 'POST',
    envelope: 'flatRecord',
    title: '验证下单优惠码',
    codes: {
      '1': '优惠码有效。',
      '-1': '优惠码无效，查看 msg。',
    },
  },
  get_msgs: {
    path: '/get_msgs',
    method: 'POST',
    envelope: 'standard',
    title: '站内消息列表',
    codes: {
      '1': '成功。',
      '-2': '非 POST。',
    },
  },
  get_onlinecode: {
    path: '/get_onlinecode',
    method: 'POST',
    envelope: 'legacyStatusRow',
    title: '我的优惠券/优惠码',
    codes: {},
  },
  paydata: {
    path: '/paydata',
    method: 'POST',
    envelope: 'statusRecord',
    title: '充值付款资料试算',
    codes: {
      '-2': '非法访问。',
    },
  },
  getBankList: {
    path: '/getBankList',
    method: 'POST',
    envelope: 'standard',
    title: '转账银行列表',
    codes: {
      '1': '成功。',
    },
  },
  getalipaylist: {
    path: '/getalipaylist',
    method: 'POST',
    envelope: 'noCode',
    title: '充值记录列表',
    codes: {},
  },
  uploadImg: {
    path: '/uploadImg',
    method: 'POST',
    envelope: 'flatRecord',
    title: '图片上传',
    codes: {
      '0': '写入失败。',
      '1': '上传成功。',
      '-1': '图片格式不合法。',
    },
  },
  alipay_rechange: {
    path: '/alipay_rechange',
    method: 'POST',
    envelope: 'statusRecord',
    title: '充值金额转换',
    codes: {
      '-2': '非法访问。',
    },
  },
  alipay_page2: {
    path: '/alipay_page2',
    method: 'POST',
    envelope: 'flatRecord',
    title: '支付宝充值资料',
    codes: {
      '1': '成功。',
      '-2': '非法访问。',
    },
  },
  alipaydetail: {
    path: '/alipaydetail',
    method: 'POST',
    envelope: 'noCode',
    title: '充值详情',
    codes: {},
  },
  ChargeResult: {
    path: '/ChargeResult',
    method: 'POST',
    envelope: 'flatRecord',
    title: '提交充值确认',
    codes: {
      '1': '提交成功。',
      '-1': '提交失败。',
    },
  },
  chargehandle: {
    path: '/chargehandle',
    method: 'POST',
    envelope: 'codeOnly',
    title: '线下充值提交',
    codes: {
      '1': '提交成功。',
    },
  },
  ajaxUpdateUserOrderPayment: {
    path: '/ajaxUpdateUserOrderPayment',
    method: 'POST',
    envelope: 'codeOnly',
    title: '线下充值后订单自动付款',
    codes: {
      '1': '更新成功。',
    },
  },
  fpxchargehandle: {
    path: '/fpxchargehandle',
    method: 'POST',
    envelope: 'legacyStatusRow',
    title: 'FPX 充值提交',
    codes: {},
  },
  m2upayHandle: {
    path: '/m2upayHandle',
    method: 'POST',
    envelope: 'flatMessage',
    title: 'M2UPay 在线充值提交',
    codes: {
      '1': '提交成功。',
      '-1': '提交失败。',
    },
  },
  m2upaySuccess: {
    path: '/m2upaySuccess',
    method: 'POST',
    envelope: 'flatMessage',
    title: 'M2UPay 充值结果查询',
    codes: {
      '1': '充值成功。',
      '2': '等待银行返回或尚未交易成功。',
      '3': '充值失败。',
      '4': '非法数据。',
      '-1': '非法访问。',
    },
  },
  currencyRate: {
    path: '/currencyRate',
    method: 'POST',
    envelope: 'flatRecord',
    title: '代付币种汇率',
    codes: {
      '1': '成功。',
      '-2': '缺少 currency。',
    },
  },
  order_modify: {
    path: '/order_modify',
    method: 'POST',
    envelope: 'statusMessage',
    title: '修改订单',
    codes: {
      '0': '修改失败、订单没有变化、订单状态不允许修改、订单状态已更新、缺少计费参数，或服务/包裹处理失败；具体原因查看 msg',
      '1': '修改成功',
    },
  },
  get_trade: {
    path: '/get_trade',
    method: 'POST',
    envelope: 'standard',
    title: '账户明细 / 交易记录',
    codes: {
      '1': '成功',
      '-1': 'token 为空或无效；用户不存在',
      '-2': '非 POST 请求',
    },
  },
  set_msgs_read: {
    path: '/set_msgs_read',
    method: 'POST',
    envelope: 'flatMessage',
    title: '站内消息设为已读',
    codes: {
      '0': '数据库错误',
      '1': '成功',
      '-1': '缺少参数或 token 无效',
      '-2': '非法访问',
    },
  },
  get_receipt_pdf_url: {
    path: '/get_receipt_pdf_url',
    method: 'POST',
    envelope: 'flatRecord',
    title: '获取收据 PDF 下载地址',
    codes: {
      '1': '成功，返回 data.pdfurl',
      '-1': '缺少 orderno；或 token 为空 / 无效',
      '-2': '订单不存在或不属于当前登录用户；非 POST 请求',
    },
  },
  molpay_pay: {
    path: '/molpay_pay',
    method: 'POST',
    envelope: 'flatRecord',
    title: 'ONLINE BANKING 充值：发起充值（供应商 2026-10-26 文档）',
    codes: {
      '0': '建单失败（写库异常），可提示稍后重试',
      '1': '下单成功，data 里带 payurl',
      '-1': '金额不合法：非数字、≤0，或低于最低金额 RM 10',
      '-2': '用户不存在（token 对应用户查不到）',
      '-3': '用了后台账号 token（这是客户接口）',
    },
  },
} as const satisfies Record<string, LegacyEndpoint>;

export type LegacyEndpointName = keyof typeof LEGACY_ENDPOINTS;
